
import React, { memo, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '@components/i18n';
import { Table } from '@components/table';
import { ItemResponse } from '@models/item';
import { restrictedItemSelector } from '@redux/slices/restricted-items';
import { Col } from 'antd';
import { SorterResult, FilterValue } from 'antd/lib/table/interface';
import { ModalContext } from 'src/contexts/modal-context';
import { columns } from '../constants';
import { EditModal } from './edit-modal';

export const Body: React.FC = memo(() => {
    const dispatch = useDispatch();
    const itemData = useSelector(restrictedItemSelector);
    const state = useSelector((state) => state);
    const modalContext = useContext(ModalContext);

    const edit = (
        data: ItemResponse,
        _: number,
        event: React.MouseEvent<HTMLElement, MouseEvent>,
    ): void => {
        if (
            !`${event.target}`.includes('SVG') &&
            !`${event.target}`.includes('Button') &&
            !`${event.target}`.includes('Span')
        )
            modalContext.setIsOpen(
                true,
                <EditModal data={data} key={`editing-item-${data.numero}`} />,
                {
                    title: `${translate('general.editItem')} - ${data.numero}`,
                    width: '40%',
                },
            );
    };

    const loadData = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pagination: any,
        _: Record<string, FilterValue>,
        sorter: SorterResult<unknown>,
    ): void => {
        //
    };

    return (
        <Col>
            <Table
                columns={columns}
                rowKey={(record: ItemResponse) => `${record.id}`}
                dataSource={itemData?.response?.content || []}
                pagination={{
                    current: itemData?.response?.number ? itemData.response.number + 1 : 1,
                    pageSize: itemData.response?.size || 10,
                    total: itemData?.response?.totalElements || 0
                }}
                pointer
                onRowClick={edit}
                scroll={{ y: 'calc(100vh - 380px)' }}
                onChange={loadData}
                isLoading={itemData?.isFetching}
            />
        </Col>
    );
});
